//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 35px 60px; // AA DI
`;
export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
export const Fields = styled.section`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 35px 60px;
`;